// crm namespace — labels of the contract's closed sets (admin/crm/contract.js *_KEYS).
// Flat dotted keys, the same set in fr / en / es (i18n/__tests__/symmetry.test.js).
export default {
  fr: {
    "enum.channel.offline": "Hors ligne",
    "enum.channel.online": "En ligne",
    "enum.consent.consented": "Consentement donné",
    "enum.consent.not_consented": "Sans consentement",
    "enum.consent.unsubscribed": "Désabonné",
    "enum.consentSource.form_tick": "Formulaire de contact",
    "enum.consentSource.import_declaration": "Déclaration à l'import",
    "enum.consentSource.signup_tick": "Case cochée à l'inscription",
    "enum.consentSource.booking_tick": "Case cochée à la réservation",
    "enum.consentSource.checkout_tick": "Case cochée à l'achat",
    "enum.consentSource.portal": "Choix du client dans son compte",
    "enum.delivery.in_person": "En présentiel",
    "enum.delivery.video": "En ligne",
    "enum.domainStatus.failed": "Échec de la vérification",
    "enum.domainStatus.not_started": "Non configuré",
    "enum.domainStatus.pending": "En attente",
    "enum.domainStatus.verified": "Vérifié",
    "enum.emailOrigin.birthday": "Anniversaire",
    "enum.emailOrigin.broadcast": "Envoi groupé",
    "enum.emailOrigin.manual": "Manuel",
    "enum.emailOrigin.nudge": "Coup de pouce",
    "enum.emailOrigin.pack_renewal": "Renouvellement de forfait",
    "enum.emailOrigin.reminder_resend": "Rappel renvoyé",
    "enum.emailOrigin.sequence": "Séquence",
    "enum.emailOrigin.test": "Test",
    "enum.emailStatus.bounced": "Rejeté",
    "enum.emailStatus.complained": "Signalé comme spam",
    "enum.emailStatus.deferred_cap": "Reporté (limite du jour)",
    "enum.emailStatus.delivered": "Distribué",
    "enum.emailStatus.failed": "Échec",
    "enum.emailStatus.opened": "Ouvert",
    "enum.emailStatus.queued": "En file d'attente",
    "enum.emailStatus.sending": "Envoi en cours",
    "enum.emailStatus.sent": "Envoyé",
    "enum.emailStatus.skipped_consent": "Ignoré : pas de consentement",
    "enum.emailStatus.skipped_suppressed": "Ignoré : adresse exclue",
    "enum.inactive.30": "Inactif depuis 30 jours ou plus",
    "enum.inactive.60": "Inactif depuis 60 jours ou plus",
    "enum.inactive.90": "Inactif depuis 90 jours ou plus",
    "enum.interaction.call": "Appel",
    "enum.interaction.meeting": "Rencontre",
    "enum.interaction.note": "Note",
    "enum.offering.course": "Cours",
    "enum.offering.pack": "Forfait",
    "enum.offering.product": "Produit",
    "enum.offering.session": "Séance",
    "enum.packFilter.active": "Forfait en cours",
    "enum.packFilter.ending": "Forfait bientôt fini (2 ou moins)",
    "enum.packFilter.finished": "Forfait terminé",
    "enum.period.30d": "30 derniers jours",
    "enum.period.7d": "7 derniers jours",
    "enum.period.90d": "90 derniers jours",
    "enum.period.custom": "Personnalisée",
    "enum.period.ytd": "Cette année",
    "enum.purchaseKind.booking": "Séance",
    "enum.purchaseKind.course": "Cours",
    "enum.purchaseKind.giftcard": "Carte-cadeau",
    "enum.purchaseKind.invoice": "Facture",
    "enum.purchaseKind.pack": "Forfait",
    "enum.purchaseKind.pathway": "Parcours",
    "enum.purchaseKind.product": "Produit",
    "enum.purchaseKind.program": "Programme",
    "enum.purchaseStatus.cancelled": "Annulé",
    "enum.purchaseStatus.free": "Gratuit",
    "enum.purchaseStatus.paid": "Payé",
    "enum.purchaseStatus.partially_refunded": "Remboursé en partie",
    "enum.purchaseStatus.pending": "En attente",
    "enum.purchaseStatus.refunded": "Remboursé",
    "enum.sequenceStatus.active": "Active",
    "enum.sequenceStatus.draft": "Brouillon",
    "enum.sessionStatus.cancelled": "Annulée",
    "enum.sessionStatus.completed": "Terminée",
    "enum.sessionStatus.no_show": "Absence",
    "enum.sessionStatus.upcoming": "À venir",
    "enum.source.booking": "Réservation",
    "enum.source.form": "Formulaire",
    "enum.source.import": "Import",
    "enum.source.manual": "Manuel",
    "enum.source.signup": "Inscription sur le site",
    "enum.source.marketplace": "Marketplace",
    "enum.source.pathway": "Parcours",
    "enum.source.purchase": "Achat",
    "enum.stage.active": "Client actif",
    "enum.stage.lead": "Prospect",
    "enum.stage.past": "Ancien client",
    "enum.stageShort.active": "Actif",
    "enum.stageShort.lead": "Prospect",
    "enum.stageShort.past": "Ancien",
    "enum.teamStatus.active": "Actif",
    "enum.teamStatus.invited": "Invité(e)",
    "enum.teamStatus.removed": "Retiré(e)",
  },
  en: {
    "enum.channel.offline": "Offline",
    "enum.channel.online": "Online",
    "enum.consent.consented": "Consented",
    "enum.consent.not_consented": "Not consented",
    "enum.consent.unsubscribed": "Unsubscribed",
    "enum.consentSource.form_tick": "Capture form",
    "enum.consentSource.import_declaration": "Import declaration",
    "enum.consentSource.signup_tick": "Ticked at sign-up",
    "enum.consentSource.booking_tick": "Ticked when booking",
    "enum.consentSource.checkout_tick": "Ticked at checkout",
    "enum.consentSource.portal": "Client's choice in their account",
    "enum.delivery.in_person": "In person",
    "enum.delivery.video": "Online",
    "enum.domainStatus.failed": "Verification failed",
    "enum.domainStatus.not_started": "Not connected",
    "enum.domainStatus.pending": "Pending",
    "enum.domainStatus.verified": "Verified",
    "enum.emailOrigin.birthday": "Birthday",
    "enum.emailOrigin.broadcast": "Broadcast",
    "enum.emailOrigin.manual": "Manual",
    "enum.emailOrigin.nudge": "Nudge",
    "enum.emailOrigin.pack_renewal": "Pack renewal",
    "enum.emailOrigin.reminder_resend": "Reminder resent",
    "enum.emailOrigin.sequence": "Sequence",
    "enum.emailOrigin.test": "Test",
    "enum.emailStatus.bounced": "Bounced",
    "enum.emailStatus.complained": "Marked as spam",
    "enum.emailStatus.deferred_cap": "Waiting for tomorrow's limit",
    "enum.emailStatus.delivered": "Delivered",
    "enum.emailStatus.failed": "Failed",
    "enum.emailStatus.opened": "Opened",
    "enum.emailStatus.queued": "Queued",
    "enum.emailStatus.sending": "Sending",
    "enum.emailStatus.sent": "Sent",
    "enum.emailStatus.skipped_consent": "Skipped: no consent",
    "enum.emailStatus.skipped_suppressed": "Skipped: suppressed",
    "enum.inactive.30": "30+ days inactive",
    "enum.inactive.60": "60+ days inactive",
    "enum.inactive.90": "90+ days inactive",
    "enum.interaction.call": "Call",
    "enum.interaction.meeting": "Meeting",
    "enum.interaction.note": "Note",
    "enum.offering.course": "Course",
    "enum.offering.pack": "Pack",
    "enum.offering.product": "Product",
    "enum.offering.session": "Session",
    "enum.packFilter.active": "On active pack",
    "enum.packFilter.ending": "Pack ending (2 or fewer left)",
    "enum.packFilter.finished": "Pack finished",
    "enum.period.30d": "Last 30 days",
    "enum.period.7d": "Last 7 days",
    "enum.period.90d": "Last 90 days",
    "enum.period.custom": "Custom",
    "enum.period.ytd": "This year",
    "enum.purchaseKind.booking": "Session",
    "enum.purchaseKind.course": "Course",
    "enum.purchaseKind.giftcard": "Gift card",
    "enum.purchaseKind.invoice": "Invoice",
    "enum.purchaseKind.pack": "Pack",
    "enum.purchaseKind.pathway": "Pathway",
    "enum.purchaseKind.product": "Product",
    "enum.purchaseKind.program": "Program",
    "enum.purchaseStatus.cancelled": "Cancelled",
    "enum.purchaseStatus.free": "Free",
    "enum.purchaseStatus.paid": "Paid",
    "enum.purchaseStatus.partially_refunded": "Partly refunded",
    "enum.purchaseStatus.pending": "Pending",
    "enum.purchaseStatus.refunded": "Refunded",
    "enum.sequenceStatus.active": "Active",
    "enum.sequenceStatus.draft": "Draft",
    "enum.sessionStatus.cancelled": "Cancelled",
    "enum.sessionStatus.completed": "Completed",
    "enum.sessionStatus.no_show": "No-show",
    "enum.sessionStatus.upcoming": "Upcoming",
    "enum.source.booking": "Booking",
    "enum.source.form": "Form",
    "enum.source.import": "Import",
    "enum.source.manual": "Manual",
    "enum.source.signup": "Site sign-up",
    "enum.source.marketplace": "Marketplace",
    "enum.source.pathway": "Pathway",
    "enum.source.purchase": "Purchase",
    "enum.stage.active": "Active client",
    "enum.stage.lead": "Lead",
    "enum.stage.past": "Past client",
    "enum.stageShort.active": "Active",
    "enum.stageShort.lead": "Lead",
    "enum.stageShort.past": "Past",
    "enum.teamStatus.active": "Active",
    "enum.teamStatus.invited": "Invited",
    "enum.teamStatus.removed": "Removed",
  },
  es: {
    "enum.channel.offline": "Fuera de línea",
    "enum.channel.online": "En línea",
    "enum.consent.consented": "Con consentimiento",
    "enum.consent.not_consented": "Sin consentimiento",
    "enum.consent.unsubscribed": "Dado de baja",
    "enum.consentSource.form_tick": "Formulario de captación",
    "enum.consentSource.import_declaration": "Declaración en la importación",
    "enum.consentSource.signup_tick": "Casilla marcada al registrarse",
    "enum.consentSource.booking_tick": "Casilla marcada al reservar",
    "enum.consentSource.checkout_tick": "Casilla marcada al comprar",
    "enum.consentSource.portal": "Elección del cliente en su cuenta",
    "enum.delivery.in_person": "Presencial",
    "enum.delivery.video": "En línea",
    "enum.domainStatus.failed": "Verificación fallida",
    "enum.domainStatus.not_started": "No conectado",
    "enum.domainStatus.pending": "Pendiente",
    "enum.domainStatus.verified": "Verificado",
    "enum.emailOrigin.birthday": "Cumpleaños",
    "enum.emailOrigin.broadcast": "Envío masivo",
    "enum.emailOrigin.manual": "Manual",
    "enum.emailOrigin.nudge": "Aviso",
    "enum.emailOrigin.pack_renewal": "Renovación de bono",
    "enum.emailOrigin.reminder_resend": "Recordatorio reenviado",
    "enum.emailOrigin.sequence": "Secuencia",
    "enum.emailOrigin.test": "Prueba",
    "enum.emailStatus.bounced": "Rebotado",
    "enum.emailStatus.complained": "Marcado como spam",
    "enum.emailStatus.deferred_cap": "En espera (límite diario)",
    "enum.emailStatus.delivered": "Entregado",
    "enum.emailStatus.failed": "Fallido",
    "enum.emailStatus.opened": "Abierto",
    "enum.emailStatus.queued": "En cola",
    "enum.emailStatus.sending": "Enviando",
    "enum.emailStatus.sent": "Enviado",
    "enum.emailStatus.skipped_consent": "Omitido: sin consentimiento",
    "enum.emailStatus.skipped_suppressed": "Omitido: dirección excluida",
    "enum.inactive.30": "30+ días inactivo",
    "enum.inactive.60": "60+ días inactivo",
    "enum.inactive.90": "90+ días inactivo",
    "enum.interaction.call": "Llamada",
    "enum.interaction.meeting": "Reunión",
    "enum.interaction.note": "Nota",
    "enum.offering.course": "Curso",
    "enum.offering.pack": "Bono",
    "enum.offering.product": "Producto",
    "enum.offering.session": "Sesión",
    "enum.packFilter.active": "Con bono activo",
    "enum.packFilter.ending": "Bono por terminar (2 o menos)",
    "enum.packFilter.finished": "Bono terminado",
    "enum.period.30d": "Últimos 30 días",
    "enum.period.7d": "Últimos 7 días",
    "enum.period.90d": "Últimos 90 días",
    "enum.period.custom": "Personalizado",
    "enum.period.ytd": "Este año",
    "enum.purchaseKind.booking": "Sesión",
    "enum.purchaseKind.course": "Curso",
    "enum.purchaseKind.giftcard": "Tarjeta regalo",
    "enum.purchaseKind.invoice": "Factura",
    "enum.purchaseKind.pack": "Bono",
    "enum.purchaseKind.pathway": "Itinerario",
    "enum.purchaseKind.product": "Producto",
    "enum.purchaseKind.program": "Programa",
    "enum.purchaseStatus.cancelled": "Cancelado",
    "enum.purchaseStatus.free": "Gratis",
    "enum.purchaseStatus.paid": "Pagado",
    "enum.purchaseStatus.partially_refunded": "Reembolsado en parte",
    "enum.purchaseStatus.pending": "Pendiente",
    "enum.purchaseStatus.refunded": "Reembolsado",
    "enum.sequenceStatus.active": "Activa",
    "enum.sequenceStatus.draft": "Borrador",
    "enum.sessionStatus.cancelled": "Cancelada",
    "enum.sessionStatus.completed": "Completada",
    "enum.sessionStatus.no_show": "No se presentó",
    "enum.sessionStatus.upcoming": "Próxima",
    "enum.source.booking": "Reserva",
    "enum.source.form": "Formulario",
    "enum.source.import": "Importación",
    "enum.source.manual": "Manual",
    "enum.source.signup": "Registro en el sitio",
    "enum.source.marketplace": "Marketplace",
    "enum.source.pathway": "Itinerario",
    "enum.source.purchase": "Compra",
    "enum.stage.active": "Cliente activo",
    "enum.stage.lead": "Contacto",
    "enum.stage.past": "Antiguo cliente",
    "enum.stageShort.active": "Activo",
    "enum.stageShort.lead": "Contacto",
    "enum.stageShort.past": "Antiguo",
    "enum.teamStatus.active": "Activo/a",
    "enum.teamStatus.invited": "Invitado/a",
    "enum.teamStatus.removed": "Eliminado/a",
  },
};
